export const PUSH_CAMPAIGN_VIEW_ROLES = ['Resort Super Admin', 'Supervisor', 'Editor'];

export const PUSH_CAMPAIGN_EDIT_ROLES = ['Resort Super Admin', 'Editor'];

export const PUSH_CAMPAIGN_LAUNCH_ROLES = ['Resort Super Admin'];

export function canViewPushCampaigns(role: string | null): boolean {
  return role != null && PUSH_CAMPAIGN_VIEW_ROLES.includes(role);
}

export function canEditPushCampaigns(role: string | null): boolean {
  return role != null && PUSH_CAMPAIGN_EDIT_ROLES.includes(role);
}

export function canLaunchPushCampaigns(role: string | null): boolean {
  return role != null && PUSH_CAMPAIGN_LAUNCH_ROLES.includes(role);
}

export function canTestSendPushCampaigns(role: string | null): boolean {
  return canEditPushCampaigns(role);
}
